// export const MASTERBASEURL = 'http://localhost:3000'

// // GET FROM INSTANCE

// export const BASEURL = 'http://localhost:3000'
// export const SOCKET_BASEURL = 'http://localhost:7000'
// export const DIGITAL_SIGN_BASEURL = "http://localhost:5000";
// export const DIGITAL_SIGN_SOCKET_BASEURL = 'http://localhost:7000';
// export const JOBS_SCHEDULE_BASEURL = '';

export const MASTERBASEURL = 'http://180.74.214.210:5000';
export const BASEURL = 'http://180.74.214.210:5000';
export const SOCKET_BASEURL = 'http://180.74.214.210:7000';
export const DIGITAL_SIGN_SOCKET_BASEURL = '';
export const JOBS_SCHEDULE_BASEURL = "";

